import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitch = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'fr' ? 'en' : 'fr');
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-1 px-3 py-2 rounded-full bg-[#3F2A24]/80 backdrop-blur-sm text-[#F3E5CF] text-xs tracking-wider uppercase font-medium shadow-lg hover:bg-[#3F2A24] transition-all duration-300 border border-[#C5A059]/30"
        data-testid="language-switch"
        aria-label="Language selection"
      >
        <span className={`transition-opacity ${language === 'fr' ? 'opacity-100' : 'opacity-50'}`}>FR</span>
        <span className="text-[#C5A059]">|</span>
        <span className={`transition-opacity ${language === 'en' ? 'opacity-100' : 'opacity-50'}`}>EN</span>
      </button>
    </div>
  );
};

export default LanguageSwitch;
